var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ImprimBookTopHeader',{on:{"show-forgot-password-modal":_vm.openForgotPasswordModal}}),_c('div',{attrs:{"id":"imprimbook-header"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }